import React, { Component } from "react";
import { connect } from "react-redux";
import { setDrawerIframe, closeDrawerIframe } from "Actions";

import DrawerComponent from "./DrawerComponent";
import styles from "./Drawer.local.scss";

export class Drawer extends Component {
  handleOpenIframe = (url, e) => {
    const {
      setDrawerIframe,
      closeDrawerIframe,
      drawerIframe,
      type,
      appType
    } = this.props;

    const { isOpen, src } = drawerIframe;

    if (type && type === "CLOSE") {
      closeDrawerIframe();
      return null;
    }

    if (src === url) {
      return null;
    }

    if (!isOpen) {
      setDrawerIframe({ url, appType: appType });
      return null;
    }

    const drawers = document.getElementsByClassName(styles.drawer);

    if (drawers && drawers.length > 0) {
      for (let i = 0; i < drawers.length; i++) {
        drawers[i].classList.remove(styles.active);
      }
      e.currentTarget.classList.add(styles.active);
    }

    closeDrawerIframe();
    //setTimeout(() => {
    setDrawerIframe({ url, appType: appType });
    //}, 400);
  };

  render() {
    return (
      <DrawerComponent {...this.props} openIframe={this.handleOpenIframe} />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  drawerIframe: state.params.drawerIframe
});

const mapDispatchToProps = dispatch => ({
  setDrawerIframe: options => dispatch(setDrawerIframe(options)),
  closeDrawerIframe: () => dispatch(closeDrawerIframe())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Drawer);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Drawer/index.js